module.exports = __webpack_public_path__ + "media/theme/icon__time-5461003f.png";